//
//
//
//

export default {
  name: 'ProductCenter',
  data() {
    return {
      msg: 'Welcome to productCenter'
    }
  },
  created() {
    this.login()
  },
  methods: {
    login() {
      console.log(this.$route.path === '/')
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        this.$router.push({ name: 'ProductCenter', params: { loginType: 'MV' } })
      } else {
        this.$router.push({ name: 'ProductPC', params: { loginType: 'PC' } })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login.vue